export type RdsNumberFormat = 'PERCENT' | 'NONE';
